{
  "mobileAppPromo": {
    "titleFirstLine": "Экскурсии, отзывы и\u00a0чат с\u00a0гидом\u00a0—",
    "titleSecondLine": "в\u00a0приложении",
    "googlePlay": "Доступно в\u00a0Google\u00a0Play",
    "appStore": "Загрузить в\u00a0App\u00a0Store"
  }
}
